import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import ScrollToTop from '../ui/ScrollToTop';
import ErrorBoundary from '../ui/ErrorBoundary';
import { ServiceFinderProvider } from '../ui/ServiceFinderContext';

export default function Layout() {
  return (
    <ServiceFinderProvider>
      <div className="flex flex-col min-h-screen">
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[60] focus:px-5 focus:py-3 focus:bg-volt-500 focus:text-night-950 focus:font-bold focus:text-sm focus:rounded-full focus:uppercase focus:tracking-wider"
        >
          Skip to main content
        </a>
        <Header />
        <main id="main-content" className="flex-1">
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </ServiceFinderProvider>
  );
}
